'use strict';

function AffiliatesCode() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this._paramName = 'affiliate_code';

  this._endpoints = {
    getOffer: '/application/affiliates/leads'
  };

  this.init = function () {
    this.$node = $(this.node);
  };

  this.getCode = function () {
    return getURLParameter(this._paramName).trim();
  };

  // This method hits the affiliates leads endpoint and retrieves the affiliates obj
  // Ref Endpoint: /affiliates/leads/internal/b20996b5-ad5c-4283-b5b9-22235eb552ab
  // https://github.com/mogofinancial/soa_docs/blob/dev/affiliates_http_documentation.md
  this.getData = function (affiliateCode, callback) {
    // Callback to handle the data being retrieved
    var httpRequest = this._endpoints.getOffer;
    // Data to the endpoint.
    var data = {
      affiliate_code: affiliateCode
    };
    // get endpoint schema
    var apiRequest = new APIRequest(httpRequest, 'GET', data, callback);
    apiRequest.send();
  };
}